//
//
//
//

export default {
  props: {
    num: {
      type: Number, default: 0
    },
    pieData: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      newPieData: [],
      pieCharts: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.pieCharts?.resize()
    },
    pieData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.pieCharts?.clear() // 清空当前实例
    this.pieCharts?.dispose() // 销毁图表
    this.pieCharts = null
  },
  methods: {
    getData () {
      this.newPieData = []
      this.pieData?.forEach((item) => {
        this.newPieData.push({
          name: item.symbol,
          value: item.value,
          rate: item.rate
        })
      })
      this.getPieCharts()
    },
    getPieCharts () {
      if (!this.pieCharts) this.pieCharts = this.$echarts.init(document.getElementsByClassName('burstdetails-pie-charts')[this.num])
      const option = {
        tooltip: {
          confine: true,
          backgroundColor: 'rgba(0,0,0,.7)',
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="box">
            ${params.marker}
            </div>
            <div>
              <div class="item"><span></span>${params.name}</div>
              <div class="item">${this.num2CurrencyNo(params.data.value)}(${params.data.rate})</div>
            </div>
            </div>`
          }
        },
        legend: {
          show: false
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '90%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 3
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontFamily: 'WikiFX',
                formatter: params => params.name
              }
            },
            data: this.newPieData
          }
        ]
      }
      this.pieCharts?.clear()
      this.pieCharts?.setOption(option, true)
    }
  }
}
